import React, { createContext, useState } from "react";
import additionalLocationService from "../services/additionalLocationService";
//import BURunChargeService from "../services/BU-RunChargeService";
import categorySecondaryOptionService from "../services/categorySecondaryOptionService";
import categoryService from "../services/categoryService";
import ColorPricingCategoryService from "../services/ColorPricingCategoryService";
import DecoMethodService from "../services/DecoMethodService";
import globalValuesService from "../services/globalValuesService";
import SetupChargeService from "../services/SetupChargeService";
import productService from "../services/productService";
import decoMethodCategoryService from "../services/decoMethodCategoryService";
import ExceptionCategoryService from "../services/ExceptionCategoryService";
import buRunChargeServices from "../services/buRunChargeServices";

const mastersContext = createContext();

const MastersContextProvider = ({ children }) => {
  debugger;

  const [decoMethods, setDecoMethods] = useState({
    loading: false,
    data: [],
  });
  const [additionalLocations, setAdditionalLocations] = useState({
    loading: false,
    data: [],
  });
  const [products, setproducts] = useState({
    loading: false,
    data: [],
  });
  const [categorySecondaryOptions, setCategorySecondaryOptions] = useState({
    loading: false,
    data: [],
  });
  const [categories, setCategories] = useState({
    loading: false,
    data: [],
  });

  const [buRunCharges, setBuRunCharges] = useState({
    loading: false,
    data: [],
  });

  const [colorPricingCategories, setColorPricingCategories] = useState({
    loading: false,
    data: [],
  });

  const [globalValues, setGlobalValues] = useState({
    loading: false,
    data: [],
  });

  const [setUpCharges, setSetupCharges] = useState({
    loading: false,
    data: [],
  });

  const [decoMethodCategory, setDecoMethodCategory] = useState({
    loading: false,
    data: [],
  });

  const [exceptionCategory, setExceptionCategory] = useState({
    loading: false,
    data: [],
  });

  const value = {
    decoMethodsState: {
      ...decoMethods,
      fetch: async () => {
        setDecoMethods({ data: [], loading: true });
        const data = await DecoMethodService.getAll();
        setDecoMethods({ data, loading: false });
      },
    },

    decoMethodCategoryState: {
      ...decoMethodCategory,
      fetch: async () => {
        setDecoMethodCategory({ data: [], loading: true });
        const data = await decoMethodCategoryService.getAll();
        setDecoMethodCategory({ data, loading: false });
      },
    },

    setupChargesState: {
      ...setUpCharges,
      fetch: async () => {
        setSetupCharges({ data: [], loading: true });
        debugger;
        const data = await SetupChargeService.getAll();
        setSetupCharges({ data, loading: false });
      },
    },

    additionalLocationState: {
      ...additionalLocations,
      fetch: async () => {
        setAdditionalLocations({ data: [], loading: true });
        const data = await additionalLocationService.getAll();
        setAdditionalLocations({ data, loading: false });
      },
    },

    productState: {
      ...products,
      fetch: async () => {
        setproducts({ data: [], loading: true });
        const data = await productService.getAll();
        setproducts({ data, loading: false });
      },
    },

    exceptionCategoryState: {
      ...exceptionCategory,
      fetch: async () => {
        setExceptionCategory({ data: [], loading: true });
        const data = await ExceptionCategoryService.getAll();
        setExceptionCategory({ data, loading: false });
      },
    },

    categorySecondaryOptionState: {
      ...categorySecondaryOptions,
      fetch: async () => {
        setCategorySecondaryOptions({ data: [], loading: true });
        const data = await categorySecondaryOptionService.getAll();
        setCategorySecondaryOptions({ data, loading: false });
      },
    },

    categoryState: {
      ...categories,
      fetch: async () => {
        setCategories({ data: [], loading: true });
        const data = await categoryService.getAll();
        setCategories({ data, loading: false });
      },
    },

    buRunChargeState: {
      ...buRunCharges,
      fetch: async () => {
        setBuRunCharges({ data: [], loading: true });
        const data = await buRunChargeServices.getAll();
        setBuRunCharges({ data, loading: false });
      },
    },

    colorPricingCategoryState: {
      ...colorPricingCategories,
      fetch: async () => {
        setColorPricingCategories({ data: [], loading: true });
        const data = await ColorPricingCategoryService.getAllColorPricingCategory();
        setColorPricingCategories({ data, loading: false });
      },
    },

    globalValuesState: {
      ...globalValues,
      fetch: async () => {
        setGlobalValues({ data: [], loading: true });
        const data = await globalValuesService.getAll();
        setGlobalValues({ data, loading: false });
      },
    },
  };

  return (
    <mastersContext.Provider value={value}>{children}</mastersContext.Provider>
  );
};

const useMastersContext = () => {
  const context = React.useContext(mastersContext);
  if (context === undefined) {
    throw new Error(
      "mastersContext must be used within a MastersContextProvider"
    );
  }
  return context;
};

export { MastersContextProvider, useMastersContext };
